import { Injectable } from '@angular/core'
import { CanActivate, Router, UrlTree } from '@angular/router'
import { AdminService, ADMIN_STORAGE_KEY } from '../services/admin.service'

function isJwtExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (!payload.exp) return false
    return Date.now() >= payload.exp * 1000
  } catch {
    return true // an undecodable token can't be trusted as valid
  }
}

@Injectable({
  providedIn: 'root',
})
export class AdminAuthGuard implements CanActivate {
  constructor(private router: Router, private adminService: AdminService) {}

  canActivate(): boolean | UrlTree {
    const key = sessionStorage.getItem(ADMIN_STORAGE_KEY)
    if (key && !isJwtExpired(key)) return true

    if (key) {
      // stale/expired token - clear it so the app doesn't keep treating the admin as logged in
      this.adminService.clearAdminKey()
    }

    return this.router.createUrlTree(['/admin/login'])
  }
}
